//import apiCheckout from '@/api/checkout';

const productSuggestions = {
    strict: true,
    namespaced: true,
    state: {
        products: [],
        mub: null,
        limit: 3,
    },
    mutations: {
        data(state, payload) { 
            state.products = payload && payload.hasOwnProperty('products') ? payload.products : [];
            state.mubData = payload && payload.hasOwnProperty('mub') ? payload.mub : null;
            state.limit = payload && payload.hasOwnProperty('limit') ? payload.limit : 3;
        },
        updateProducts(state, payload) { 
            state.products = payload;
        },
    },
    actions: {
        setData(context, payload, dispatch, rootState, rootGetters){
            context.commit('data', payload);
        },
        setProducts(context, payload){
            context.commit('updateProducts', payload);
        },
    },
    getters: {
        products: state => state.products,
        mubData: state => state.mubData,
        limit: state => state.limit,
    },
};

export default productSuggestions;
